import { T } from '../../../../utils/I18n/I18n';
import React, { useRef, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import FormInput from '../../../../components/UI/FormInput/FormInput';
import { CITY_BY_POSTCODE } from '../../../../queries/customer';
import { countryCode } from '../../../../utils/checkout';
import './PostcodeAndCity.scss';

const PostcodeAndCity = ({ register, errors, setValue, watch }) => {
  const client = useApolloClient();

  const [showUnderCity, setShowUnderCity] = useState(false);
  const [cities, setCities] = useState(null);

  const setCity = (val, validate = false) => setValue('city', val, validate);
  const setPostcode = (val, validate = false) => setValue('postcode', val, validate);
  const currentCountry = watch && watch('country_code', countryCode);
  const noFetch = watch && currentCountry !== countryCode;

  const citiesTimeoutId = useRef();

  const selectCityHandler = (city, postcode) => {
    setCity(city, true);
    setPostcode(postcode.toString(), true);
    setCities(null);
  };

  const postcodeHandler = e => {
    setCities(null);

    if (citiesTimeoutId.current) {
      clearTimeout(citiesTimeoutId.current);
    }

    if (!e.target.value) {
      return;
    }

    if (e.target.value.length > 8) {
      setPostcode(e.target.value.substring(0, 8));
      return;
    }

    const postCode = Number(e.target.value);

    setCity('');

    citiesTimeoutId.current = setTimeout(async () => {
      const { data } = await client.query({
        query: CITY_BY_POSTCODE,
        variables: { postCode },
      });

      if (postCode) {
        setShowUnderCity(false);
        setCities(data.citiesByPostcode);
      }
    }, 300);
  };

  const cityHandler = e => {
    setCities(null);

    if (citiesTimeoutId.current) {
      clearTimeout(citiesTimeoutId.current);
    }

    if (!e.target.value) {
      return;
    }

    const city = e.target.value;

    setPostcode('');

    citiesTimeoutId.current = setTimeout(async () => {
      const { data } = await client.query({
        query: CITY_BY_POSTCODE,
        variables: { city },
      });

      if (city) {
        setShowUnderCity(true);
        setCities(data.citiesByPostcode);
      }
    }, 300);
  };

  return (
      <>
        <div className="city-by-postcode__container">
          <FormInput
              register={register}
              type="number"
              text={<T id="address.postcode" />}
              name="postcode"
              errors={errors}
              onChange={noFetch ? undefined : postcodeHandler}
              noAutoComplete
          />

          {cities && !showUnderCity && (
              <div className="city-by-postcode__list">
                {cities.map(({ city, postcode }) => (
                    <p key={city + postcode} onClick={() => selectCityHandler(city, postcode)}>
                      {city} {postcode}
                    </p>
                ))}

                {!cities.length && (
                    <p>
                      <T id="address.noResults" />
                    </p>
                )}
              </div>
          )}
        </div>

        <div className="city-by-postcode__container">
          <FormInput
              register={register} // Przekazujemy funkcję register
              name="city" // Nazwa pola
              type="text"
              text={<T id="address.city" />}
              errors={errors}
              onChange={noFetch ? undefined : cityHandler}
              noAutoComplete
              required={true} // Opcjonalnie: reguły jako prop
              validate={value => (!/\d/.test(value) ? true : <T id="address.cityNotValid" />)} // Walidacja jako prop
          />

          {cities && showUnderCity && (
              <div className="city-by-postcode__list">
                {cities.map(({ city, postcode }) => (
                    <p key={city + postcode} onClick={() => selectCityHandler(city, postcode)}>
                      {city} {postcode}
                    </p>
                ))}

                {!cities.length && (
                    <p>
                      <T id="address.noResults" />
                    </p>
                )}
              </div>
          )}
        </div>
      </>
  );
};

export default PostcodeAndCity;